import { SxProps, Theme } from '@mui/material';

export const styles = {
  container: {
    padding: 1,
  } as SxProps<Theme>,

  header: {
    marginBottom: 3,
  } as SxProps<Theme>,

  householdCard: {
    marginBottom: 2,
    '&:hover': {
      boxShadow: 4,
    },
  } as SxProps<Theme>,

  householdHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 2,
  } as SxProps<Theme>,

  householdTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  } as SxProps<Theme>,

  membersList: {
    marginTop: 2,
  } as SxProps<Theme>,

  memberItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    paddingLeft: 0,
  } as SxProps<Theme>,

  ownerChip: {
    marginLeft: 'auto',
  } as SxProps<Theme>,

  actionsContainer: {
    display: 'flex',
    gap: 1,
    marginTop: 2,
  } as SxProps<Theme>,

  invitePanel: {
    marginTop: 2,
    padding: 2,
    backgroundColor: 'grey.50',
    borderRadius: 1,
  } as SxProps<Theme>,

  inviteForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  } as SxProps<Theme>,

  formActions: {
    display: 'flex',
    gap: 1,
    justifyContent: 'flex-end',
  } as SxProps<Theme>,

  emptyState: {
    textAlign: 'center',
    padding: 4,
    color: 'text.secondary',
  } as SxProps<Theme>,
};
